import { mainAPIUrl } from '../../../settings';

const baseURL = `${mainAPIUrl}/gservices_3/ss`;

/**
 * Validates delivery eligibility for an address using the zoning API
 * Endpoint: GET /gservices_3/ss/zoning/v2
 * 
 * @param {Object} params - Zoning validation parameters
 * @param {number} params.lat - Latitude
 * @param {number} params.lng - Longitude
 * @param {string} params.state - State/province
 * @param {string} params.country - Country
 * @param {string} params.productId - Product SKU ID
 * @param {string} params.orderId - Order ID
 * @returns {Promise<{code: string, data: Object}>} Zoning validation response with delivery config
 * @throws {Error} Throws error with code and response details if validation fails
 */
export const validateZoning = async ({ lat, lng, state, country, productId, orderId }) => {
  const url = `${baseURL}/zoning/v2?lat=${lat}&lng=${lng}&state=${state}&country=${country}&productId=${productId}&orderId=${orderId}&source=smartsend`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  });

  const json = await response.json();

  // Handle error responses
  if (!response.ok || json.code === 'ERROR') {
    const errorCode = json.message?.code || json.message;
    const errorMessage = json.message?.message || json.message;

    const error = new Error(errorMessage || `Zoning validation failed: ${response.status}`);
    error.code = errorCode;
    error.response = json;
    throw error;
  }

  // Return the data from successful response
  return {
    code: json.code,
    data: json.data?.data || json.data,
  };
};
